// No direct PHP counterpart.
// Shared JS helper for:
// - api/fuel/app/classes/controller/api/monty/custom/rename/create.php
// - api/fuel/app/classes/controller/api/monty/custom/rename/delete.php
// - api/fuel/app/classes/controller/api/monty/custom/nesting/add.php
// - api/fuel/app/classes/controller/api/monty/custom/nesting/remove.php
// - api/fuel/app/classes/controller/api/monty/custom/nesting/clear.php
// - api/fuel/app/classes/controller/api/monty/custom/nesting/restore.php
import DB from 'offline/db'
import Constants from 'offline/constants'
import User from 'offline/model/user'

function json(data) {
	return {
		session: { offline: true },
		data: data
	}
}

export function ok(data) {
	return Promise.resolve(json(data))
}

export function persist(data) {
	return DB.save().then(function() {
		return json(data)
	})
}

export function invalid(code) {
	return Promise.reject({ error: code || Constants.API_ERROR_INVALID, offline: true })
}

export function unauthorised() {
	return Promise.reject({ error: Constants.API_ERROR_UNAUTHORISED, offline: true })
}

export function currentUser(params) {
	var userId = Number(params.sessionUserId || DB.meta('sync_user_id') || 0) || 0
	return userId ? User.with_id(userId) : null
}

export function touchUser(user) {
	if (!user) return
	DB.run('UPDATE user SET user_data_version = ? WHERE user_id = ?', [
		Math.floor(Date.now() / 1000),
		user.get_id()
	])
}
